import { Dialog, UseDialogReturnType } from 'components';
import dayjs from 'dayjs';
import useTimeZone from 'hooks/use-timezone';
import { Dispatch, FC, SetStateAction } from 'react';

type GroupBy = Extract<dayjs.OpUnitType, 'month' | 'week' | 'day' | 'hour'>;

interface DateRangeDialogProps {
  dialogProps: UseDialogReturnType;
  timeRange: number;
  groupBy?: GroupBy;
  setTimeRange: Dispatch<SetStateAction<number>>;
  setGroupBy?: Dispatch<SetStateAction<GroupBy>>;
}

const DateRangeDialog: FC<DateRangeDialogProps> = ({
  dialogProps,
  groupBy = 'day',
  timeRange,
  setGroupBy,
  setTimeRange
}) => {
  const { dateInputToUtc, newZonedDayJs, utcToZonedDate } = useTimeZone();

  return (
    <Dialog closeDialog={dialogProps.closeDialog} ref={dialogProps.ref} id="date-range-dialog" width="400px">
      <h4 className="text-info-dark">CUSTOMIZE GRAPH</h4>
      <div className="d-flex align-items-center justify-content-end g-3">
        <label>LAST</label>
        <input type="number" value={timeRange} onChange={e => setTimeRange(Number(e.target.value))} min={1} max={99} />
        <select disabled={!setGroupBy} value={groupBy} onChange={e => setGroupBy?.(e.target.value as GroupBy)}>
          <option value="hour">HOURS</option>
          <option value="day">DAYS</option>
          <option value="week">WEEKS</option>
          <option value="month">MONTHS</option>
        </select>
      </div>
      <div className="p-relative">
        <hr className="my-5" />
        <label id="hr-or" className="p-1 p-absolute text-base">
          OR
        </label>
      </div>
      <div className="d-flex align-items-center g-3">
        <input
          className="flex-grow-1"
          type="date"
          value={utcToZonedDate(newZonedDayJs().subtract(timeRange - 1, groupBy))}
          onChange={e => setTimeRange(newZonedDayJs().diff(dateInputToUtc(e.target.value), groupBy) + 1)}
          max={utcToZonedDate(newZonedDayJs().subtract(1, 'day'))}
        />
        <span className="material-icons icon-large">arrow_forward</span>
        <input type="date" defaultValue={utcToZonedDate(newZonedDayJs().toISOString())} disabled />
      </div>
    </Dialog>
  );
};

export default DateRangeDialog;
